import type {Post} from '../types';

export function isStatic(gif: Post): boolean {
    return gif.flags?.includes('static') || false;
}
